import { injectable, inject } from 'inversify';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import Request from '@framework/api/Rpc/Request';
import { type IDispatcherFactory } from '@dataroom/json-rpc-dispatcher';
import DITypes from '@dataroom/json-rpc-dispatcher/DITypes';
import { IQuestionsEmailAlerts } from '../domain/vo/QuestionsEmailAlerts';
import { IRealtime } from '../domain/vo/IRealtime';
import { IDaily } from '../domain/vo/IDaily';
import { IWeekly } from '../domain/vo/IWeekly';

@injectable()
class UserEmailAlertsRepository {
  constructor(
    @inject(DITypes.JsonRpcDispatcher) private readonly rpc: IDispatcherFactory,
  ) {}

  updateUploadNotificationSettings = async (
    payload: {
      dataroomName: string,
      notifications: {
        realtime: IRealtime,
        daily: IDaily,
        weekly: IWeekly,
      },
      userIds?: number[],
    },
  ): Promise<void> => {
    const request = new Request('dataroom.users.update_upload_notification_settings', payload);
    const response = await this.rpc().call<RpcSuccess>(request);

    return response.getResult();
  };

  updateStagingUploadNotificationSettings = async (payload: {
    dataroomName: string,
    notifications: {
      stagingRealtime: IRealtime,
      stagingDaily: IDaily,
      stagingWeekly: IWeekly,
    },
    userIds?: number[],
  }): Promise<void> => {
    const request = new Request('dataroom.users.update_staging_notification_settings', payload);
    const response = await this.rpc().call<RpcSuccess>(request);

    return response.getResult();
  };

  updateDigestNotificationSettings = async (
    payload: {
      dataroomName: string,
      notifications: {
        digestDaily: IDaily,
        digestWeekly: IWeekly,
      },
      userIds?: number[],
    },
  ): Promise<void> => {
    const request = new Request('dataroom.users.update_digest_notification_settings', payload);
    const response = await this.rpc().call<RpcSuccess>(request);

    return response.getResult();
  };

  updateAccessRequestNotificationSettings = async (
    payload: {
      dataroomName: string,
      notifications: {
        accessRequestRealtime: IRealtime,
        accessRequestDaily: IDaily,
        accessRequestWeekly: IWeekly,
      },
      userIds?: number[],
    },
  ): Promise<void> => {
    const request = new Request('dataroom.users.update_access_request_notification_settings', payload);
    const response = await this.rpc().call<RpcSuccess>(request);

    return response.getResult();
  };

  updateQuestionNotificationSettings = async (
    payload: {
      dataroomName: string,
      notifications: IQuestionsEmailAlerts,
      userIds?: number[],
    },
  ): Promise<void> => {
    const request = new Request('qna.user.notification_settings.update', payload);
    const response = await this.rpc().call<RpcSuccess>(request);

    return response.getResult();
  };
}

export default UserEmailAlertsRepository;
